import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from '@angular/material/snack-bar';

export interface DetailedMessage {
  message: string;
  details?: string[];
}

@Component({
  selector: 'h3-detailed-message',
  templateUrl: './detailed-message.component.html',
  styleUrls: ['./detailed-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DetailedMessageComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: DetailedMessage,
    private snackBarRef: MatSnackBarRef<DetailedMessageComponent>,
  ) {}

  dismiss() {
    this.snackBarRef.dismiss();
  }
}
